import { createAsyncThunk } from "@reduxjs/toolkit";
import { post } from "../../lib/request";

interface payloadData {
  name: string;
  company_key: string;
  email: string;
  password: string;
  password_confirmation: string;
  mobile: string;
  country: string;
}

export const registerUser = createAsyncThunk(
  "auth/user_registeration",
  async (
    {
      name,
      company_key,
      email,
      password,
      password_confirmation,
      mobile,
      country,
    }: payloadData,
    { rejectWithValue }
  ) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const payload = {
        name,
        company_key,
        email,
        password,
        password_confirmation,
        mobile,
        country,
      };

      const { data } = await post("/user/register", payload, config);
      localStorage.setItem("access_token", data?.access_token);
      console.log(data);
      return data;
    } catch (error: any) {
      // return custom error message from backend if present
      console.log("signup err:", error);
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
